import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { getThemePreference, setThemePreference, subscribeTheme } from "../../theme/preference";
import { MonitorIcon, MoonIcon, SunIcon } from "../icons";

export function ThemeSwitcher() {
  const { t } = useTranslation("common");
  const preference = useSyncExternalStore(subscribeTheme, getThemePreference, () => "system");
  const Icon = preference === "system" ? MonitorIcon : preference === "dark" ? MoonIcon : SunIcon;
  const options = [
    { value: "light", label: t("appearance.light") },
    { value: "dark", label: t("appearance.dark") },
    { value: "system", label: t("appearance.system") },
  ];
  return (
    <label className="inline-flex h-control shrink-0 items-center gap-1.5 rounded-sm border border-line bg-surface pl-2 text-data text-ink-2">
      <Icon size={14} />
      <span className="sr-only">{t("appearance.label")}</span>
      <select
        className="h-full min-w-0 cursor-pointer rounded-sm bg-surface pr-2 text-ink"
        value={preference}
        onChange={(event) => {
          const value = event.target.value;
          if (value === "light" || value === "dark" || value === "system")
            setThemePreference(value);
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
